export const MAX_RESTORE_AGE_MS = 30 * 60 * 1000 // 30 minutes
export const MAX_PAUSED_AGE_MS = 10 * 60 * 1000 // 10 minutes
